import { render, staticRenderFns } from "./GeneratePandIReports.vue?vue&type=template&id=612549b9&scoped=true&"
import script from "./GeneratePandIReports.vue?vue&type=script&lang=js&"
export * from "./GeneratePandIReports.vue?vue&type=script&lang=js&"
import style0 from "./GeneratePandIReports.vue?vue&type=style&index=0&id=612549b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612549b9",
  null
  
)

export default component.exports